export default "__VITE_ASSET__TBJDYyRR__"